import { useEffect } from 'react';
import Plans from '@/components/Plans';
import Footer from '../Footer';
import { ContainerWrapper, Title } from './legacyStyle';
import { useTranslation } from 'react-i18next';
import useResize from '@/hooks/useResize';
import { Helmet } from 'react-helmet';
import FAQ from './FAQ';
import LocalizedPageLinks from '@/components/SEO/LocalizedPageLinks';

const Pricing = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const { isMobile } = useResize();

    useEffect(() => {
      // 取得網址的#後面的字串
      const hash = window.location.hash;
      // 如果有hash值，就滾動到該元素
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }, []);

  return (
    <>
      <Helmet>
        <title>{t('seo.pricing.title')}</title>
        <meta itemProp="name" content={t('seo.pricing.title')} />
        <meta property="og:title" content={t('seo.pricing.title')} />
        <meta name="twitter:title" content={t('seo.pricing.title')} />
        <meta name="description" content={t('seo.pricing.metaDescription')} />
        <meta property="og:description" content={t('seo.pricing.metaDescription')} />
        <meta name="twitter:description" content={t('seo.pricing.metaDescription')} />
      </Helmet>
      <LocalizedPageLinks pagePath="/Subscription" />
      <ContainerWrapper>
        <Title isMobile={isMobile}>{t('pages.index.Pricing.title')}</Title>
        <Plans />
        <FAQ />
      </ContainerWrapper>
      <Footer />
    </>
  );
};

export default Pricing;
